// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SupplierWiseAPIStockPage_inputContainer__2-80-"};